// extracted by mini-css-extract-plugin
export var active = "styles-module--active--J9ssq";
export var buttonContainer = "styles-module--buttonContainer--cl4ma";
export var closeButton = "styles-module--closeButton--sLEMz";
export var closeButtonIcon = "styles-module--closeButtonIcon--srnkv";
export var modal = "styles-module--modal--ah9Nq";
export var modalBackground = "styles-module--modalBackground--9iBB0";
export var text = "styles-module--text--IWQYP";